
export default function ReviewCTA() {
  return (
    <section className="py-16 px-6 bg-gradient-to-br from-amber-500 to-amber-600">
      <div className="max-w-4xl mx-auto text-center">
        <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-white/20 backdrop-blur-sm rounded-full">
          <i className="fas fa-star text-4xl text-white"></i>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Love Our Service?
        </h2>
        
        <p className="text-base text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
          Your feedback helps us improve and helps others find quality painting and decorating services. Share your experience with Brushour and let others know about the quality work we deliver.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <a
            href="https://www.google.com/search?q=brushour+painters+and+decorators"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-8 py-4 bg-white hover:bg-beige-50 text-gray-800 font-medium rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="fab fa-google text-2xl text-red-600"></i>
            <span>Review on Google</span>
          </a>
          <a
            href="https://www.trustpilot.com/review/brushour.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-8 py-4 bg-white hover:bg-beige-50 text-gray-800 font-medium rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="fas fa-star text-2xl text-green-600"></i>
            <span>Review on Trustpilot</span>
          </a>
        </div>

        <div className="flex items-center justify-center gap-6 text-white/80 text-sm">
          <div className="flex items-center gap-2">
            <i className="fas fa-clock"></i>
            <span>Takes 2 minutes</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="fas fa-shield-alt"></i>
            <span>100% Secure</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="fas fa-heart"></i>
            <span>Greatly Appreciated</span>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-white/20">
          <p className="text-sm text-white/80">
            You can also leave a review on{' '}
            <a
              href="https://www.facebook.com/brushour"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-white transition-colors cursor-pointer"
            >
              Facebook
            </a>
            {' '}or share your experience via WhatsApp at{' '}
            <a
              href="https://wa.me/447595037441"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-white transition-colors cursor-pointer"
            >
              07595037441
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
